import ApiEndpointConstants from '../constants/api/ApiEndpointConstants';
import api from './STORY_BASE_API';

export const getStoryInfoById = (id) => {
    return api.post(
        `${ApiEndpointConstants.STORY_DETAIL}`, {id});
}